<div id="media-lab" class="inner-page py-5">
  <div class="container-fluid px-lg-5">
    <h2 class="title text-uppercase mb-2">Media Production & Editing Lab (BAJMC)</h2>
    <p class="inner-lead mt-3">
      The Media Production Lab at Shah Satnam Ji Girls' College is a specialized facility for the Bachelor of Arts in Journalism and Mass Communication (BAJMC) department, providing students with hands-on experience in the world of media.
    </p>

    <hr class="divider">

    <div class="row g-4 mt-2 mb-5">
      <div class="col-md-6">
        <h4 class="section-subtitle text-success">Studio Facilities</h4>
        <ul class="inner-lead">
          <li><strong>Audio & Visual Studios:</strong> Purpose-built studios designed for professional-grade recording and broadcasting.</li>
          <li><strong>Professional Equipment:</strong> Equipped with high-definition cameras, professional microphones, and lighting kits.</li>
          <li><strong>Live Streaming:</strong> Capabilities for live news reporting and digital content broadcasting.</li>
        </ul>
      </div>
      <div class="col-md-6">
        <h4 class="section-subtitle text-success">Post-Production</h4>
        <ul class="inner-lead">
          <li><strong>Editing Suites:</strong> Dedicated workstations for video and audio post-production.</li>
          <li><strong>Industry Software:</strong> Access to industry-standard tools for non-linear editing (NLE) and sound design.</li>
          <li><strong>Creative Skills:</strong> Hands-on training in digital content creation, media management, and script writing.</li>
        </ul>
      </div>
    </div>

    <!-- Media Lab Gallery Section -->
    <div class="gallery-section mt-5">
      <h3 class="gallery-title text-center mb-4">Media Lab Showcase</h3>
      
      <div class="row g-4 justify-content-center">
        <div class="col-12 col-sm-6 col-md-4" *ngFor="let img of mediaImages">
          <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
            <img [src]="img" alt="Media Studio Equipment" class="img-fluid w-100" style="object-fit: cover; height: 240px; transition: transform 0.3s ease;">
            <div class="gallery-overlay d-flex align-items-center justify-content-center">
              <span class="zoom-icon"><i class="fas fa-search-plus"></i> View Lab</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fullscreen Backdrop-Blurred Lightbox -->
    <div class="lightbox-backdrop d-flex align-items-center justify-content-center animate-fade-in" *ngIf="activeLightboxImage" (click)="closeLightbox()">
      <div class="lightbox-content position-relative" (click)="$event.stopPropagation()">
        <button class="btn-close-lightbox" (click)="closeLightbox()">&times;</button>
        <img [src]="activeLightboxImage" class="lightbox-img img-fluid rounded-3" alt="Fullscreen Media Production Lab View">
      </div>
    </div>

    <div class="mt-5 text-center">
       <p class="text-muted small"><em>Empowering future journalists and digital storytellers.</em></p>
    </div>

  </div>
</div>

